import React from "react";
import Boracay from "./Boracay";

export default function BoracayContainer({ onComplete, count }) {
  const [stateCount] = React.useState(count);

  return stateCount === count ? (
    <div className="absolute bg-red" style={{ left: "-1rem", top: "-1rem" }}>
      <Boracay onComplete={onComplete}></Boracay>
    </div>
  ) : (
    <></>
  );
}
